const bottomBar = {
  editMode: "Edit Mode",
  done: "Done",
  pickSlot: "Pick Item",
  clearSlot: "Clear Slot",
  pages: "Pages",
  widgets: "Widgets",
  longPressToEdit: "Long press to edit",
  sidebar: "Menu",
  widgetPanel: "Widgets",
  emptySlot: "Empty",
  editBottomBar: "Edit Bottom Bar",
  menu: "Menu",
  more: "More",
  navigation: "Navigation",
  openMenu: "Open menu",
  closeMenu: "Close menu",
} as const;
export default bottomBar;
